import type { User, ProjectConfig, Card, CardBalance, CardDetails, Tx, TxLast, CreateSessionResponse } from '@/types/shared'

export const useMainStore = defineStore('main_store', {
	state: () => ({
        // 
        is_dev_disable_redirects: false,

        // 
        is_tg_back_button_handler_inited: false,
		is_tg_back_button_visible: false,
        tg_back_button_handler: () => {},

        // 
        is_tg_main_button_handler_inited: false,
        is_tg_main_button_visible: false,
        tg_main_button_text: '',
        tg_main_button_color: '#2ABF77',
        tg_main_button_handler: () => {},

        // 
        is_tg_secondary_button_handler_inited: false,
        is_tg_secondary_button_visible: false,
        tg_secondary_button_text: '',
        tg_secondary_button_color: '#2ABF77',
        tg_secondary_button_handler: () => {},

        // 
        is_privacy_policy_modal_visible: false,

        // 
        is_card_topup_modal_visible: false,
        card_topup_modal_card_id: false,

        // 
        is_card_txs_modal_visible: false,
        need_reopen_card_txs_modal: false,

        is_card_tx_info_modal_visible: false,
        card_tx_info_modal_item: null as Tx | null,

        // 
        is_top_menu_modal_visible: false,
	}),

    getters: {
        is_tg_bottom_menu_visible: (state) => {
            if (state.is_tg_main_button_visible || state.is_tg_secondary_button_visible) {
                return true
            }
            return false 
        },
        is_ios: (state) => {
            return window?.Telegram?.WebApp?.platform === 'ios'
        },
        is_tg: (state) => {
            return window?.Telegram?.WebApp?.platform != 'unknown'
            // return true
        }
    },

	actions: {
		set_value(key: string, value: any) {
            this[key] = value
        }
	}
})